import * as React from "react";
import type { OvertimeItem } from "../../@apis/dto/response/torunament.response";
import { cn } from "../../lib/utils/cn";

interface OvertimeAccordionProps {
  overtime: OvertimeItem;
  currentUserId: number;
  defaultOpen?: boolean;
}

export default function OvertimeAccordion({
  overtime,
  currentUserId,
  defaultOpen = false,
}: OvertimeAccordionProps) {
  const [open, setOpen] = React.useState(defaultOpen);
  const isConfirmed = overtime.status === "CONFIRMED";

  return (
    <div className="overflow-hidden ">
      {/* 헤더 */}
      <button
        type="button"
        className="flex w-full items-center justify-between gap-2 py-2"
        onClick={() => isConfirmed && setOpen((v) => !v)}
      >
        <div className="flex min-w-0 items-center gap-x-2">
          <span
            className={`shrink-0 whitespace-nowrap rounded-[5px] px-2 py-0.5 text-center text-sm ${isConfirmed ? "bg-white text-black border border-[#C7C7CC]" : " bg-black text-white"}`}
          >
            {isConfirmed ? "종료" : "진행중"}
          </span>
          <span className="min-w-0 break-keep text-sm font-semibold text-[#222]">
            연장전 {overtime.sequence}차
          </span>
        </div>

        <div className="flex shrink-0 items-center gap-[8px]">
          {isConfirmed && (
            <img
              src="/icons/ic-arrow-down.png"
              alt="toggle"
              className="size-6"
              style={{
                transform: open ? "rotate(0deg)" : "rotate(180deg)",
                transition: "transform 0.2s ease",
              }}
            />
          )}
        </div>
      </button>

      {/* 바디: 진행 중이면 항상 표시, 종료면 open 상태에 따라 */}
      {(!isConfirmed || open) && (
        <div>
          {/* 코스/홀/파 헤더 행 */}
          <div
            className={cn(
              "flex items-center justify-between gap-2 px-2.5 py-1.5 min-h-8 *:font-semibold *:text-[0.9375rem]",
              isConfirmed
                ? "bg-[#E5E5EA] *:text-black"
                : "bg-black *:text-white",
            )}
          >
            <span className="min-w-0 break-keep">
              {overtime.golfCourseName}코스 {overtime.holeNo}홀
            </span>
            <span className="shrink-0 whitespace-nowrap">PAR {overtime.par}</span>
          </div>

          {/* 선수 행 */}
          {overtime.scores.map((s, i) => {
            const isMe = s.userId === currentUserId;
            return (
              <div
                key={s.userId}
                className={`flex min-h-8 items-center justify-between gap-2 px-[15px] py-1 ${i > 0 ? "border-t border-[#f0f0f0]" : ""}`}
              >
                <div className="min-w-0 *:font-semibold *:text-black">
                  <span className="break-keep [overflow-wrap:anywhere]">
                    {s.userName}
                    {isMe && "(나)"}
                  </span>
                </div>
                <span
                  className={cn(
                    "shrink-0 whitespace-nowrap",
                    s.isConfirmed
                      ? "text-[#222] font-semibold"
                      : "text-[#8E8E93] ",
                  )}
                >
                  {s.isConfirmed ? s.score : "진행중"}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
